export function PrivacyPage() {
  return (
    <article className="legal-document">
      <h1>Política de Privacidade e Proteção de Dados Pessoais (LGPD)</h1>
      <p className="text-muted">
        LONDON SIM GESTÃO DE DOCUMENTOS LTDA (Datasci Editora) — CNPJ 22.390.588/0001-70
        <br />
        Em total conformidade com a Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018).
      </p>

      <section>
        <h2>1. Papéis de Atuação</h2>
        <p>
          Nos termos do art. 5º da Lei nº 13.709/2018 (LGPD), a <strong>LONDON SIM GESTÃO DE DOCUMENTOS LTDA</strong> atua como:
        </p>
        <ul>
          <li>
            <strong>Controladora de Dados:</strong> em relação aos dados cadastrais e financeiros de compradores individuais
            (consumidores B2C) e visitantes da plataforma.
          </li>
          <li>
            <strong>Operadora de Dados:</strong> em relação aos dados de colaboradores e funcionários disponibilizados por
            empresas contratantes (tenants corporativos B2B) para fins exclusivos de concessão de licenças e acesso aos ebooks
            contratados pelo empregador.
          </li>
        </ul>
      </section>

      <section>
        <h2>2. Dados Coletados e Finalidades de Tratamento</h2>
        <p>
          Coletamos estritamente os dados necessários para a execução dos contratos e cumprimento de obrigações legais:
        </p>
        <ul>
          <li>
            <strong>Identificação e Contato:</strong> e-mail institucional ou pessoal e nome completo. Finalidade: autenticação de
            sessão, emissão de links mágicos/OTP, entrega de pedidos e comunicações transacionais essenciais (art. 7º, V da LGPD).
          </li>
          <li>
            <strong>Dados de Cobrança e Faturamento:</strong> identificador único de cobrança Pix e dados bancários transmitidos
            ao gateway Universal Pagamentos. Finalidade: liquidação de transações e cumprimento de obrigações contábeis e fiscais
            (art. 7º, II da LGPD).
          </li>
          <li>
            <strong>Dados Técnicos e de Segurança:</strong> registros de log, hash de endereço IP pseudonimizado (HMAC-SHA256) e
            tokens temporários de download. Finalidade: prevenção a fraudes, proteção contra pirataria e cumprimento do Marco Civil
            da Internet (Lei nº 12.965/2014, art. 15).
          </li>
        </ul>
      </section>

      <section>
        <h2>3. Medidas Técnicas de Segurança da Informação</h2>
        <p>
          Adotamos salvaguardas técnicas avançadas de segurança e privacidade por design (<em>Privacy by Design</em>):
        </p>
        <ul>
          <li>
            <strong>Criptografia em Repouso (AES-256-GCM):</strong> todos os campos contendo dados pessoais identificáveis
            (e-mail, telefone, nome de colaboradores) são cifrados com criptografia autenticada antes da persistência no banco de
            dados D1.
          </li>
          <li>
            <strong>Índices Determinísticos por HMAC:</strong> pesquisas e deduplicações de registros utilizam resumos criptográficos
            HMAC-SHA256 com segredos protegidos em ambiente seguro (Cloudflare Secrets), inviabilizando qualquer reversão não
            autorizada.
          </li>
          <li>
            <strong>Auditoria de Acesso:</strong> todas as operações de leitura, mutação administrativa e tentativas negadas são
            registradas na tabela imutável de trilha de auditoria (<code>audit_events</code>).
          </li>
        </ul>
      </section>

      <section>
        <h2>4. Período de Retenção e Ciclo de Vida dos Dados</h2>
        <p>
          Os dados pessoais serão retidos pelo período estritamente necessário:
        </p>
        <ul>
          <li>
            <strong>Compradores Individuais:</strong> mantidos enquanto ativa a conta de acesso ao acervo digital e pelo prazo
            prescricional legal de 5 (cinco) anos para guarda de registros fiscais e comprovação de direitos autorais.
          </li>
          <li>
            <strong>Colaboradores Corporativos:</strong> retidos por até <strong>36 (trinta e seis) meses</strong> após o
            encerramento do contrato com o tenant corporativo, momento no qual são definitiva e irreversivelmente anonimizados ou
            eliminados de nossos registros.
          </li>
        </ul>
      </section>

      <section>
        <h2>5. Direitos dos Titulares de Dados</h2>
        <p>
          Em conformidade com o artigo 18 da LGPD, você possui o direito de solicitar a qualquer momento:
        </p>
        <ul>
          <li>Confirmação da existência de tratamento e acesso estruturado aos seus dados pessoais;</li>
          <li>Correção de dados incompletos, inexatos ou desatualizados;</li>
          <li>Anonimização, bloqueio ou eliminação de dados desnecessários ou tratados em desconformidade com a lei;</li>
          <li>Portabilidade dos dados em formato legível por máquina (JSON/CSV);</li>
          <li>Revogação do consentimento, quando esta for a base legal aplicável.</li>
        </ul>
      </section>

      <section>
        <h2>6. Contato com o Encarregado de Proteção de Dados (DPO)</h2>
        <p>
          Para exercer quaisquer de seus direitos ou esclarecer dúvidas sobre o tratamento de seus dados pessoais, entre em
          contato com o nosso Encarregado pelo endereço exclusivo:{" "}
          <a href="mailto:contato@datasci.com.br">contato@datasci.com.br</a> com o assunto &ldquo;LGPD — Direitos do Titular&rdquo;.
        </p>
      </section>
    </article>
  );
}
